import { render, staticRenderFns } from "./OutOfOfficeFunctionbox.vue?vue&type=template&id=78a68efc&"
import script from "./OutOfOfficeFunctionbox.vue?vue&type=script&lang=js&"
export * from "./OutOfOfficeFunctionbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78a68efc')) {
      api.createRecord('78a68efc', component.options)
    } else {
      api.reload('78a68efc', component.options)
    }
    module.hot.accept("./OutOfOfficeFunctionbox.vue?vue&type=template&id=78a68efc&", function () {
      api.rerender('78a68efc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OutOfOfficeFunctionbox.vue"
export default component.exports